import { HTTPError } from "ky";

import { userApi, authApi } from "api";
import { ISignupSubmitData } from "models/User";

export const handleErrorMessage = async (errorResponse: HTTPError, t) => {
  const errorBody = await errorResponse?.response?.json();
  let errorMessage;

  if (errorResponse?.response?.status === 409) {
    errorMessage = t("errors.email_already_taken");
  } else if (errorBody?.errors) {
    const errors = errorBody.errors;
    const arrayMessages = Object.keys(errors).map((key) => {
      return `${key} ${errors[key]}`;
    });

    errorMessage = arrayMessages.join(", ") || t("errors.something_went_wrong");
  } else {
    errorMessage = errorBody?.error || t("errors.something_went_wrong");
  }

  return errorMessage;
};

export const signupUser = async (data: ISignupSubmitData) => {
  return authApi.authCreateUser(data).then((response) => {
    const [error] = response;
    const errorResponse = error as HTTPError;
    if (errorResponse?.response.status === 409) {
      return response;
    }
    return userApi.signupSession(data);
  });
};
